import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './InReviewCard.module.css';
const InReviewCard = () => {
  return <div className={css.reviewBatch}><FormattedMessage id='Circle.inReview'/></div>;
};

export default InReviewCard;
